import { Box, CardMedia } from "@material-ui/core"
import { useState } from "react"
import type { ReactElement } from "react"

import "./card-thumbnail.styles.scss"

export interface ICardThumbnailProps {
  image?: string
}

export function CardThumbnail({ image }: ICardThumbnailProps): ReactElement {
  const [imageLoaded, setImageLoaded] = useState<boolean>(false)

  return (
    <Box className="card-thumbnail-container">
      <CardMedia
        component="img"
        onLoad={() => setImageLoaded(true)}
        image={image && imageLoaded ? image : `${process.env.PUBLIC_URL}/images/imagePlaceholder.png`}
        className={"map-thumbnail"}
      />
    </Box>
  )
}
